import axios from "axios";
import { API_SERVER, TIMEOUT_API_POST_IN_MILISECUNDES } from "config";

const apiManager = axios.create({
  baseURL: API_SERVER,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: TIMEOUT_API_POST_IN_MILISECUNDES,
});

export default apiManager;